export const EC20_RESPONSE_TYPE = 'code'

/**
 * 访问权限
 * read_orders: 读取订单
 * write_orders: 写入订单
 * read_store_information: 读取店铺信息
 * read_store_metrics: 读取店铺统计
 * read_products: 读取商品
 * write_products: 写入商品
 */
export const EC20_SCOPE = 'read_orders,write_orders,read_store_information,read_store_metrics,read_products,write_products'

export const EC20_SOURCE = 'SHOPLINE02'
